// ============================================================================
//  Wymiary FIBA i parametry sceny — JEDNO ŹRÓDŁO PRAWDY.
//  Wszystkie jednostki w metrach (1 jednostka three.js = 1 metr).
//  Standard FIBA. Modelujemy POŁOWĘ boiska (od linii końcowej do środkowej).
// ============================================================================

// Małe boisko przydomowe (kompaktowa płyta z jednym koszem).
export const COURT = {
  WIDTH: 7.5,             // szerokość płyty (oś X)
  HALF_LENGTH: 7.0,       // od linii końcowej do tylnej krawędzi (oś Z)
  LINE_WIDTH: 0.05,       // szerokość linii malowanych (5 cm)
  MARGIN: 0.5,            // wąski wybieg poza linie (do krawędzi płyty)
}

export const HOOP = {
  RIM_RADIUS: 0.225,          // promień wewn. obręczy (średnica 0,45 m)
  RIM_TUBE: 0.0125,           // grubość pręta obręczy
  RIM_HEIGHT: 3.05,           // wysokość obręczy nad parkietem
  // Środek obręczy od linii końcowej. Regulaminowo 1,575 m, ale model HoopAir D72 jest
  // sztywny i jego mocowanie wchodziło ~11 cm na boisko; kosz cofnięto o 0,113 m
  // (przód mocowania na linii końcowej), więc obręcz i wszystko, co się od niej liczy
  // (symulacja rzutu, półkole no-charge, łuk za 3 pkt), siedzi na 1,462 m.
  RIM_FROM_BASELINE: 1.462,   // środek obręczy od linii końcowej (po cofnięciu kosza)
  BOARD_WIDTH: 1.80,
  BOARD_HEIGHT: 1.05,
  BOARD_THICKNESS: 0.04,
  BOARD_BOTTOM: 2.90,         // dolna krawędź tablicy nad parkietem
  BOARD_FROM_BASELINE: 1.20,  // przednia płaszczyzna tablicy od linii końcowej
  INNER_RECT_W: 0.59,         // prostokąt celowniczy
  INNER_RECT_H: 0.45,
  INNER_RECT_BOTTOM_ABOVE_RIM: 0.15, // dolna krawędź prostokąta nad obręczą
}

// Linie w skali przydomowej. TRUMNA i koło RW są ZAWSZE w wymiarze FIBA —
// wymóg klientki (25.08.2026): trumna ma mieć 16×19 szt przy koszu w pozycji 0
// (tak są projektowane wszystkie layouty produkcyjne, nawet małe P100F ma pole
// 16 szt). 4,90×5,80 m po dociągnięciu w dół do pełnych płytek daje 16×19 szt
// dla każdego modelu płytki (30,1–30,5 cm). Compact różni się od FIBA już
// tylko dosunięciem prostych łuku za 3 pkt do linii bocznych (mniejszy inset).
export const LINES = {
  THREE_PT_RADIUS: 5.00,      // ref. (NIE steruje łukiem — patrz THREE_PT)
  THREE_PT_SIDE_INSET: 0.60,  // proste odcinki od linii bocznej
  KEY_WIDTH: 4.90,            // pole (paint) — wymiar FIBA (16 szt po dociągnięciu)
  FREE_THROW_FROM_BASELINE: 5.80, // linia RW — wymiar FIBA (19 szt po dociągnięciu)
  FREE_THROW_CIRCLE_R: 1.80,
  NO_CHARGE_R: 1.25,          // półkole „no-charge" pod koszem
  CENTER_CIRCLE_R: 1.80,      // nieużywane na boisku przydomowym
}

// Regulaminowy zestaw linii FIBA (połowa boiska, jeden kosz) — używany przez
// presety standardowe. Wartości w metrach. Środek obręczy (HOOP.RIM_FROM_BASELINE)
// jest wspólny dla obu zestawów — łuki i półkole liczą się od niego.
export const LINES_FIBA = {
  THREE_PT_RADIUS: 6.75,      // ref. (NIE steruje łukiem — patrz THREE_PT)
  THREE_PT_SIDE_INSET: 0.90,  // proste odcinki od linii bocznej
  KEY_WIDTH: 4.90,            // szerokość pola (paint)
  FREE_THROW_FROM_BASELINE: 5.80,
  FREE_THROW_CIRCLE_R: 1.80,
  NO_CHARGE_R: 1.25,          // półkole „no-charge" pod koszem
  CENTER_CIRCLE_R: 1.80,      // nieużywane na połowie (dla spójności kształtu)
}

// Promienie łuków za 3 punkty — STAŁE, niezależne od spec (compact/fiba).
// Senior = regulamin FIBA (6,75 m); junior = świadomie przyjęty krótszy łuk
// młodzieżowy (6,00 m). FIBA nie ma jednej oficjalnej linii młodzieżowej.
export const THREE_PT = { SENIOR: 6.75, JUNIOR: 6.00 }

// Predefiniowane wymiary boiska. Presety przydomowe: cele w METRACH (oś X =
// szerokość sideline↔sideline, oś Z = głębokość od linii końcowej), liczba
// płytek liczona na żywo: tiles = ceil(target / tileM) → płyta zawsze ≥ standard.
// `spec` przełącza zestaw linii ('compact' = przydomowy LINES, 'fiba' =
// regulaminowy LINES_FIBA). Linie zawsze na krawędzi siatki płytek.
//
// Presety FIBA definiowane w PŁYTKACH (tilesW/tilesL, nie w metrach): pole gry
// wg layoutów produkcyjnych Epufloor (50×36 szt ≈ 15,2×10,9 m dla SES Battle).
// 3×3 ma pole gry NIEZMIENNE (regulamin 11×15 m) — `lock` wyłącza steppery obu
// osi; w 5×5 szerokość jest stała (50 szt), a długość wolno regulować (boisko
// niewymiarowe), ale pole gry ≤ maxCourtLenM = 28 m (pełny kort).
// Preset „Mały" startuje BEZ wybiegu (runoffDefault: 0 nadpisuje CONFIG.RUNOFF)
// — kort i od razu obrzeże. Samo zejście do 0 jest dozwolone wszędzie
// (CONFIG.RUNOFF.min = 0), więc presety nie mają własnego minimum.
export const PRESETS = [
  { id: 'small',   label: 'Mały',          targetW: 5.5,  targetL: 7.5,  spec: 'compact', runoffDefault: 0 },
  { id: 'medium',  label: 'Średni',        targetW: 7.5,  targetL: 9.0,  spec: 'compact' },
  { id: 'large',   label: 'Duży',          targetW: 9.0,  targetL: 11.0, spec: 'compact' },
  { id: 'fiba3x3', label: 'FIBA 3×3', tilesW: 50, tilesL: 36, spec: 'fiba', lock: ['widthTiles', 'lengthTiles'] },
  { id: 'fiba5x5', label: 'FIBA 5×5', tilesW: 50, tilesL: 36, spec: 'fiba', lock: ['widthTiles'], maxCourtLenM: 28 },
]

export const BALL = {
  RADIUS: 0.13,               // rozmiar 7 (średnica ~0,24 m)
}

export const NET = {
  SEGMENTS: 10,               // segmenty obwodowe (pierścień)
  ROWS: 7,                    // rzędy w dół
  LENGTH: 0.40,               // długość siatki
  TOP_RADIUS: 0.225,          // przy obręczy
  BOTTOM_RADIUS: 0.105,       // zwężenie u dołu
}

// Paleta i parametry sceny
export const SCENE = {
  DAY_EXPOSURE: 1.3,
  NIGHT_EXPOSURE: 0.85,
  COURT_COLOR: 0x1f6fb5,      // niebieskie boisko (fallback do czasu wczytania tekstury)
  PAINT_COLOR: 0x14538c,      // pole malowane (ciemniejszy niebieski)
  LINE_COLOR: 0xffffff,       // białe linie
}

// Parametry nawierzchni z płytek (tekstura zamiast jednolitego koloru).
// Strefy są renderowane unlit (MeshBasic) — baza to WYSIWYG (piksel == swatch),
// na to nałożone TYLKO delikatne podbicie jasności (110%). Wcześniejsze mocne
// podbicie (nasycenie 120%, jasność 160%) przekłamywało odcienie przez clipping
// kanałów: czerwony wpadał w pomarańcz, niebieski/zielony w neon (uwaga Kasi
// 25.08.2026 „odcienie trzeba poprawić"). Swatche w tiles.json są od tej pory
// kalibrowane do ZDJĘĆ realnych płytek (docs/poprawki/.../_docx_media), nie do
// wzornika. Wartości zaszyte na stałe (bez suwaków w UI).
export const SURFACE = {
  LINE_PAINT_OPACITY: 0.9,   // krycie linii 80% — wyraźne linie, ale faktura/struktura płytki przebija przez farbę
  SATURATION: 1.0,           // bez podbicia nasycenia (wierność odcieni z palety)
  BRIGHTNESS: 1.1,           // delikatny lift jasności (słoneczny plener), bez clippingu kanałów
  // Siła faktury sterowana ZOOMEM (dystans kamery do środka boiska). Z daleka kratka
  // i spoiny są nieczytelne i migoczą, więc gasimy je do zera (płaskie lico = czysty
  // kolor strefy); przy zbliżeniu faktura narasta do TILE_TEX_MAX. Sterowane uniformem
  // czytanym CO KLATKĘ (nie wpiekane w shader przez onBeforeCompile) — reaguje na żywo
  // i na zoom, i na zmianę tych stałych. Widok 2D z góry przelicza zoom orto na
  // ekwiwalentny dystans perspektywy, więc te same progi gaszą fakturę w obu widokach.
  TILE_TEX_MAX: 0.9,    // maks. siła faktury przy bliskim zoomie (0 = płasko, 1 = pełne spoiny)
  TILE_TEX_NEAR: 1.0,   // dystans kamery [m]: ≤ to → pełna faktura (TILE_TEX_MAX)
  TILE_TEX_FAR: 8.0,   // dystans kamery [m]: ≥ to → brak faktury (0, płasko)
  // Łapacz cienia: strefy są unlit (MeshBasic, nie odbierają cieni), więc realny cień
  // piłki/kosza pada na osobną, przezroczystą warstwę z ShadowMaterial tuż nad nawierzchnią.
  SHADOW_OPACITY: 0.32, // krycie cienia na nawierzchni (0 = niewidoczny, 1 = czarny)
}

// Pozycja środka obręczy w przestrzeni świata.
// Linia końcowa na Z=0, boisko rozciąga się w +Z. Środek X = 0.
export const RIM_CENTER = {
  x: 0,
  y: HOOP.RIM_HEIGHT,
  z: HOOP.RIM_FROM_BASELINE,
}

// Środek półboiska (miejsce kozłowania) — połowa długości między linią
// końcową a środkową.
export const COURT_CENTER = {
  x: 0,
  z: COURT.HALF_LENGTH / 2, // 7 m od linii końcowej
}

// Punkt, z którego oddawany jest rzut — tam gdzie piłka kozłuje (środek).
export const SHOOT_FROM = {
  x: 0,
  y: BALL.RADIUS,
  z: COURT_CENTER.z,
}

// Konfigurator: wymiary w LICZBIE PŁYTEK (metry = płytki × rozmiar płytki).
// Domyślne pochodzą z tiles.json#default; tu trzymamy granice min/max suwaków.
export const CONFIG = {
  WIDTH:  { default: 27, min: 18, max: 50 },
  // max 92: pole gry do 28 m (pełny kort FIBA) przy najmniejszej płytce —
  // limit długości regulowanej w presecie 5×5 i sufit trybu ręcznego.
  LENGTH: { default: 27, min: 20, max: 92 },
  // Wybieg wolno zejść do 0 w KAŻDYM presecie i w trybie ręcznym (kort, a zaraz
  // za linią obrzeże) — presety różnią się już tylko wartością startową
  // (runoffDefault: „Mały" startuje z 0, reszta z 3).
  RUNOFF: { default: 3,  min: 0,  max: 7 },
}

// Strefy kolorów nawierzchni — klucze odpowiadają state.colors. JEDNO ŹRÓDŁO
// etykiet: sekcja „Kolory" w UI (controls) renderuje strefy bez colorKey w
// LINE_DEFS, a builder wyceny iteruje wszystkie. `linesThree`/`linesJr` mają
// swatche pod wierszami linii 3 pkt (sekcja „Linie"), więc w sekcji Kolory ich
// nie pokazujemy — etykiety służą payloadowi wyceny i aria.
export const ZONES = [
  { key: 'court',      label: 'Kort' },
  { key: 'key',        label: 'Trumna' },
  { key: 'runoff',     label: 'Wybieg' },
  { key: 'edge',       label: 'Obrzeże' },
  { key: 'lines',      label: 'Linie' },
  { key: 'linesThree', label: 'Linie — 3 pkt senior' },
  { key: 'linesJr',    label: 'Linie — junior' },
]

// Definicje linii boiska — klucze odpowiadają state.lines. JEDNO ŹRÓDŁO etykiet:
// sekcja „Linie" w UI i builder wyceny. `colorKey` (gdy obecny) wskazuje strefę
// koloru sterowaną swatchem przy danej linii (junior → linesJr). `excludes`
// (gdy obecny) — linia, którą włączenie tej gasi (lineToggle): półkole i koło
// rzutów wolnych to dwa warianty jednego oznaczenia; kolejność = kolejność w
// UI, domyślny wariant (półkole) nad kołem.
export const LINE_DEFS = [
  { key: 'key',      label: 'Pole (trumna)' },
  { key: 'ftHalf',   label: 'Półkole rzutów wolnych', excludes: 'ftCircle' },
  { key: 'ftCircle', label: 'Koło rzutów wolnych', excludes: 'ftHalf' },
  { key: 'ticks',    label: 'Ticki na pasie' },
  { key: 'three',    label: 'Linia za 3 pkt — senior (6,75 m)', colorKey: 'linesThree' },
  { key: 'threeJr',  label: 'Linia za 3 pkt — junior (6,00 m)', colorKey: 'linesJr' },
  { key: 'noCharge', label: 'Półkole no-charge' },
]
